module.exports = __webpack_public_path__ + "static/media/boat-img-25.a316a9b6.jpg";